'use strict';

// https://en.wikipedia.org/wiki/Identity_function
var index = function index(i) {
  return i;
};
module.exports = index;